import { useMediaQuery } from "react-responsive";

export const theme = {
    colors: {
      primary: '#82B83F ',
      primaryLight: '#bce76e',
      primaryDark: '#2C5C10',
      secondary: '#2ecc71',
      santafe: '#a36751',
      naviLinkColor: '#edebdd',
      background: '#f5f5f5',
      laser: '#c4ae60',
      text: '#333',
    },
    breakpoints: {
      mobileMini: "360px",
      mobileMedium: "412px",
      mobileBig: "450px",
      ipadMini: "768px",
      ipadMedium: "820px",
      ipadBig: "912px",
      miniNotebook: "1024px",
      desktop: "1200px",
      desktopFull: "1600px",
      desktopFK: "2200px"
    }
};

export const useScreens = () => {
  const isDesktopFull = useMediaQuery({ query: '(min-width: 2540px)' });
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1200px)' });
  const isMiniNotebook = useMediaQuery({ query: '(max-width: 1024px)' });
  const isIpadBig = useMediaQuery({ query: '(max-width: 912px)' });
  const isIpadMedium = useMediaQuery({ query: '(max-width: 820px)' });
  const isIpadMini = useMediaQuery({ query: '(max-width: 750px)' });

  return {
    isDesktopFull,
    isDesktopOrLaptop,
    isMiniNotebook,
    isIpadBig,
    isIpadMedium,
    isIpadMini
  };
};

export const useIsDesktopBig = () => {
  return useMediaQuery({
    query: '(max-width: 1960px)',
  });
};

export const useIsDesktopMedium = () => {
  return useMediaQuery({
    query: '(max-width: 1440px)',
  });
};

export const useIsDesktopOrLaptop = () => {
  return useMediaQuery({
    query: '(max-width: 1200px)',
  });
};

export const useIsMiniNotebook = () => {
  return useMediaQuery({
    query: '(max-width: 1023px)',
  });
};

export const useIsMobileBig = () => {
  return useMediaQuery({
    query: '(max-width: 760px)',
  });
};
export const useIsMobileMedium = () => {
  return useMediaQuery({
    query: '(max-width: 600px)',
  });
};
export const useIsMobileMini = () => {
  return useMediaQuery({
    query: '(max-width: 500px)',
  });
};
  /*
  const isIpadMedium = useMediaQuery({
    query: '(max-width: 820px)'
  });
  const isIpadMini = useMediaQuery({
    query: '(max-width: 768px)'
  });
  const isMobileBig = useMediaQuery({
    query: '(max-width: 450px)'
  });
  const isMobileMedium = useMediaQuery({
    query: '(max-width: 412px)'
  });
  const isMmobileMini = useMediaQuery({
    query: '(max-width: 360px)'
  })
}

 */